import { t } from 'i18next';
import { toast } from 'react-toastify';
import { CancelledError } from '@tanstack/react-query';

import { ToastMessage } from '@/ui-kit/toaster/ToastMessage';
import { TAppState } from '@/store/reducers/reducers';
import { IApiError, IErrorAction, ICanceledAction } from '@/store/types/base.state';

import { TAppActionsAndErrorAction } from '@/store/types/app.types';
import { TMiddleware } from '@/types/middleware';

export const toasterMiddleware: TMiddleware<TAppState, TAppActionsAndErrorAction> = (_) => (next) => (action) => {
  if (action.shouldSkipToaster) return next(action);

  if (action.type?.includes('SUCCESS')) {
    toast.success(
      <ToastMessage
        message={t(`layout.notification.success.${action.type.replace('.', '_')}`)}
        documentation={action.documentation}
      />,
      { icon: false, autoClose: 4000, theme: 'dark' },
    );
    return next(action);
  }

  if (action.type?.includes('FAIL') && isFailApiAction(action)) {
    const { error, type } = action;
    toast.error(
      <ToastMessage
        message={t((action.error as IApiError)?.errors?.[0]?.message)}
        documentation={action.documentation}
        payload={{ type, error }}
      />,
      { icon: false, autoClose: false, theme: 'dark' },
    );
    return next(action);
  }

  if (isFailUiAction(action)) {
    if (isCanceledAction(action)) {
      /* TODO : Action on cancel ?
      const canceledQueries = getQueries({ canceled: true });
      const keys = canceledQueries.map((q) => (Array.isArray(q.queryKey) ? q.queryKey[0] : q.queryKey));
      const list = new Set();
      keys.forEach((key) => list.add(key));

      toast.success(
        <ToastMessage message={`${Array.from(list).join(', ')} query canceled`} documentation={action.documentation} />,
        { autoClose: 4000 }
      );*/
    } else {
      console.error(action.error);

      const { error, type } = action;

      const message = 'message' in error ? error.message : JSON.stringify(action.error);
      toast.error(
        <ToastMessage message={t(message)} documentation={action.documentation} payload={{ type, error }} />,
        {
          icon: false,
          theme: 'dark',
          autoClose: false,
        },
      );
      return next(action);
    }
  }

  next(action);
};

const isFailApiAction = (action: TAppActionsAndErrorAction): action is IErrorAction =>
  Array.isArray(((action as IErrorAction).error as IApiError)?.errors);

const isFailUiAction = (action: TAppActionsAndErrorAction): action is IErrorAction =>
  Boolean((action as IErrorAction)?.error);

const isCanceledAction = (action: TAppActionsAndErrorAction): action is ICanceledAction =>
  Boolean(((action as IErrorAction)?.error as CancelledError)?.revert);
